import { render, staticRenderFns } from "./MediaSlots.vue?vue&type=template&id=92d7820a&scoped=true&"
import script from "./MediaSlots.vue?vue&type=script&lang=js&"
export * from "./MediaSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d7820a",
  null
  
)

export default component.exports